import { Skeleton } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { CardSection, DetailsSection } from '../../LearningSkeleton';

function PreviewSkeleton() {
  return (
    <div className="overflow-auto flex absolute flex-col w-full inset-0">
      <div className="border flex justify-center items-center bg-transparent py-3">
        <Skeleton className="w-36" variant="text" size="lg" />
      </div>
      <div className="mx-auto flex w-full flex-col xl:container sm:pt-10 bg-[#C5C5C51F]">
        <DetailsSection />
      </div>
      <CardSection />
    </div>
  );
}

export default observer(PreviewSkeleton);
